import { createRoot } from 'react-dom/client';

import App from './App';
import { initSentry } from './sentry';

import './index.css';

// Initialize error monitoring before the app renders
initSentry();

createRoot(document.getElementById('root')!).render(<App />);
